import React, { useState } from 'react';
import { priceFormatter } from '../../../../helpers/formatters';
import CurrencyIcon from '../../../../shared/components/Icons/Currency';
import Tooltip from '../../Tooltip';
import Styled from './styles';
import COLORS from '../../../../constants/COLORS';
import Currency from '../../../../shared/components/Currency';
import useSeat from '../../../../hooks/useSeat';
import { isMobile } from '../../../../helpers/device';
import type { ITicketsController } from '../../../../lib/widget/tickets/tickets.interface';
import { useInjection } from 'inversify-react';
import { TICKETS_MODULE_IDS } from '../../../../lib/widget/tickets/tickets.types';

interface SeatProps {
  ticket: any;
  colors: any;
  fade?: boolean;
}

const Seat = ({ ticket, colors, fade }: SeatProps) => {
  const ticketsController: ITicketsController = useInjection(TICKETS_MODULE_IDS.TICKETS_CONTROLLER);
  const { selected, toggleSelected } = useSeat({ ticket });

  const [tooltipCoords, setTooltipCoords] = useState<{
    top: number;
    left: number;
  } | null>(null);

  const showTooltip = (evt) => {
    let closeTimer;

    const { top, left, height } = evt.target.getBoundingClientRect();

    setTooltipCoords({
      top: top + height,
      left,
    });

    if (closeTimer) {
      clearTimeout(closeTimer);
    }

    if (isMobile()) {
      closeTimer = setTimeout(hideTooltip, 2000);
    }
  };

  const hideTooltip = () => setTooltipCoords(null);
  return (
    <>
      <Styled.Seat
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
        color={colors[ticket.price] || '#fff'}
        selected={selected}
        activeColor={COLORS.BLUE}
        onClick={() => {
          if (selected) {
            ticketsController.remove(ticket);
          } else {
            ticketsController.add(ticket);
          }
          toggleSelected(!selected);
        }}
        fade={fade}
        data-selenium="seat"
      >
        {ticket.seat}
      </Styled.Seat>

      {tooltipCoords && (
        <Tooltip
          style={{ top: tooltipCoords.top, left: tooltipCoords.left, position: 'fixed' }}
          message={
            <Currency>
              {priceFormatter(ticket.price)} <CurrencyIcon fill="#fff" width={8} height={10} />
            </Currency>
          }
        />
      )}
    </>
  );
};

export default Seat;
